import { buildUrl } from '@axa-fr-axion/restful';

const MIN_CHARACTER_FOR_SEARCH = 2;
const buildPostalAddressUrl = (config, address) => buildUrl(
  [
    config.amabisHost,
    config.amabisEndpoint
  ],
  {
    Adr1: address
  }
);
const toPostalAddresses = (addresses) => {
  return (addresses || []).map((data) => {
    const address = [data.adr4, data.adr3].join(" ").trim();
    const [postalCode, ...rest] = data.adr6.split(" ");
    const city = rest.join(" ");
    return {
      full: data.adr,
      address,
      city,
      postalCode
    };
  });
};

export { MIN_CHARACTER_FOR_SEARCH as M, buildPostalAddressUrl as b, toPostalAddresses as t };
